module.exports = __webpack_public_path__ + "static/media/trash.bafafb07.svg";